import { render, staticRenderFns } from "./comprasRapidas.vue?vue&type=template&id=4f345aa1&"
import script from "./comprasRapidas.vue?vue&type=script&lang=js&"
export * from "./comprasRapidas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports